import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import Footer from '../../Footer/Footer';
import Greetings from '../grettings/Greetings';
import Header from '../Header/Header';
import HomeBlogs from '../HomeBlogs/HomeBlogs';
import Projects from '../Projects/Projects';
//import Login from "../../Auth/Login";
import { UserContext } from '../../../App';

const Home = () => {
  const { userData, setUserData } = useContext(UserContext);
  //console.log(userData);
  return (
    <div className="spinner">
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="Azim Uddin Ahamed"
          content="Azim Uddin Ahamed . Web Application Developer  "
        />
      </Helmet>
      <Header />
      {/* <Login /> */}
      <Greetings />
      <Projects />
      <HomeBlogs />
      <Footer></Footer>
    </div>
  );
};

export default Home;
